import { render, staticRenderFns } from "./LogActivity.vue?vue&type=template&id=2194debc&scoped=true&"
import script from "./LogActivity.vue?vue&type=script&lang=js&"
export * from "./LogActivity.vue?vue&type=script&lang=js&"
import style0 from "./LogActivity.vue?vue&type=style&index=0&id=2194debc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194debc",
  null
  
)

export default component.exports